<script setup lang="ts">
import type { IService } from '@types';
import { getServiceImages } from '@sub/utils/images';

const props = withDefaults(defineProps<{
  service?: IService;
  defaultImage?: string;
  active?: boolean;
}>(), {
  service: () => ({} as IService),
  defaultImage: '',
  active: false,
});

const images = computed(() => getServiceImages(props.service));

defineEmits(['open:images']);
</script>

<template lang="pug">
.service-card.p-11.br-20.w-296.h-100.flex.flex-shrink-0.overflow-hidden.text-none(:class="{active}")
  .flex.row-16.overflow-hidden
    UiImage.s-76.flex-shrink-0(:src="getServiceImages(service)[0]" :placeholder="defaultImage" :border="false" @click.prevent.stop="$emit('open:images', images)")
    .flex.col-8
      span.service-title.typ-13-17-400 {{ service.title }}
      span.service-address.typ-13-17-300.text-ellipsis {{ service.addresses?.[0]?.country }}
</template>

<style scoped lang="scss">
@use "@ui/styles/scss/colors" as *;

.service-card {
  border: 1px solid #EDEDF2;
  background: $color-white;
  opacity: .5;
  transition: opacity 0.5s ease;

  &.active {
    opacity: 1;
  }
}

.service-title {
  color: #1F1F1F;
}

.service-address {
  color: #5B646D;
}
</style>